<script lang="ts">
    import FileTextIcon from '../../icons/FileTextIcon.svelte';
    import { initCkEditorEmbeds } from '../initCkEditorEmbeds';
    import * as t from '../../translations/Petitions.ts';
    
    export let text: string = '';
    export let header: string = '';
    export let maxHeight: number = 200; // px before collapsing

    let expanded = false;
    let contentElement: HTMLElement;
    let needsExpansion = false;

    function toggleExpanded() {
        expanded = !expanded;
    }

    // Check if content overflows
    $: if (contentElement) {
        needsExpansion = contentElement.scrollHeight > maxHeight;
    }


</script>

<div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
    <!-- Header -->
    <div class="px-5 py-2.5 bg-gray-100 border-b border-gray-200">
        <h3 class="!text-base !leading-6 !font-semibold text-gray-700 flex items-center gap-2 !m-0" data-testid="petition-text-header">
            <FileTextIcon width="16" height="16" />
            {header || t.Petition_Text_Header()}
        </h3>
    </div>

    <!-- Content -->
    <div class="relative">
        <div 
            bind:this={contentElement}
            class="px-5 py-4 text-base text-gray-700 leading-relaxed max-w-none transition-all duration-300 overflow-hidden"
            style="max-height: {expanded ? 'none' : maxHeight + 'px'};"
        >
            {#if text}
                <div class="ck-content" use:initCkEditorEmbeds>
                    {@html text}
                </div>
            {:else}
                <p class="text-gray-500 italic">{t.No_Petition_Text()}</p>
            {/if}
        </div>

        <!-- Gradient overlay when collapsed -->
        {#if needsExpansion && !expanded}
            <div class="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        {/if}
    </div>

    <!-- Expand/Collapse Button -->
    {#if needsExpansion}
        <div class="px-5 pb-4">
            <button 
                class="text-sm font-medium text-teal-600 hover:text-teal-700 flex items-center gap-1 transition-colors"
                on:click={toggleExpanded}
            >
                {#if expanded}
                    <span>{t.Show_Less()}</span>
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
                    </svg>
                {:else}
                    <span>{t.Read_Full_Text()}</span>
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                    </svg>
                {/if}
            </button>
        </div>
    {/if}
</div>

<style>
    /* Responsive iframes for YouTube/video embeds */
    .ck-content :global(iframe) {
        max-width: 100%;
        height: auto;
        aspect-ratio: 16 / 9;
    }
    /* Twitter embed styling */
    .ck-content :global(.twitter-tweet) {
        margin: 1em auto !important;
    }
</style>
